export default {
  diligence: 'Start',
  searches: 'Searches',
  ofac: 'OFAC',
  documents: 'Organizational Documents',
  goodStanding: 'Good Standing',
  charterDocuments: 'Charter Documents'
};
